import { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";

//Components
import { Modal, ModalBody, ModalFooter, Button, Form, Input, Select, ToggleSwitch, RadioButton } from "@gpstrackit/react-controls";
import { DatePicker } from "@gpstrackit/gtc-react-controls";
import { NotificationManager } from 'Components/Notifications';
import { Grid } from "@mui/material";
import moment from 'moment';
import { HasPermission } from "Core/security";

//Actions
import {
    featureTabUpdateUnitRequest,
    clearRedux,
    featureTabResult,
    devicegetDataRequest,
    featureTabGetDeviceRequest,
    searchEntityRequest,
    featureTabRequest,
} from 'Redux/actions';

import { getBillingAccounts } from 'Modules/dealers/views/.components/deleteBillingAccount/redux/slice';

const UpdateFeature = (props) => {
    const { tableRef, getDevice } = props;
    const dispatch = useDispatch();
    const { messages } = useIntl();
    const formRef = useRef(null);

    const { openModal, loading, result, deviceId, currentDevice } = useSelector(state => state.featureTabUpdateFeatureRedux);
    const timeZones = useSelector(state => state.generalRedux.timeZones);
    const deviceModels = useSelector(state => state.generalRedux.deviceModels);
    const manufacturers = useSelector(state => state.generalRedux.manufacturers);
    const tags = useSelector(state => state.generalRedux.tags);
    const user = useSelector(state => state.securityRedux.user);
    const loadingEntity = useSelector(state => state.generalRedux.loadingEntity);
    const { billingAccounts } = useSelector(state => state.deleteBillingAccountRedux)

    //Local states
    const [show, setShow] = useState(false);
    const [hybrid, setHybrid] = useState(false);
    const [apu, setApu] = useState(false);
    const [deviceCategory, setDeviceCategory] = useState("Asset");
    const [label, setLabel] = useState("");
    const [promiles, setPromiles] = useState(false);
    const [promilesOdometerCalculated, setPromilesOdometerCalculated] = useState(false);
    const [analytics, setAnalytics] = useState(false);
    const [vbus, setVbus] = useState(false);
    const [jbus, setJbus] = useState(false);
    const [useEcuSpeed, setUseEcuSpeed] = useState(false);
    const [useEcuOdometer, setUseEcuOdometer] = useState(false);
    const [useEcuEngineHours, setUseEcuEngineHours] = useState(false);
    const [useEcuVin, setUseEcuVin] = useState(false);
    const [driverBehavior, setDriverBehavior] = useState(false);
    const [device, setDevice] = useState(null);
    const [linkedMode, setLinkedMode] = useState(false);
    const [cariq, setCariq] = useState(false);
    const [carb, setCarb] = useState(false);
    const [deviceModel, setDeviceModel] = useState(null);
    const [installed, setInstalled] = useState(null);
    const [installedOn, setInstalledOn] = useState(null);
    const [liveMode, setLiveMode] = useState("Streaming")
    const [selectedTags, setSelectdTags] = useState([]);
    const [billingAccountId, setBillingAccountId] = useState(null);

    const closeModal = () => {
        setShow(false);
        setHybrid(false);
        setApu(false);
        setDeviceCategory("Asset");
        setLabel("");
        setPromiles(false);
        setPromilesOdometerCalculated(false);
        setAnalytics(false);
        setVbus(false);
        setJbus(false);
        setUseEcuSpeed(false);
        setUseEcuOdometer(false);
        setDriverBehavior(false);
        dispatch(clearRedux("FEATURE_TAB_UPDATE_FEATURES"));
        setUseEcuVin(false);
        setLinkedMode(false);
        setDeviceModel(null);
        setCariq(false);
        setInstalled(null);
        setInstalledOn(null);
        setLiveMode("Streaming");
        setBillingAccountId(null);
        setUseEcuEngineHours(false);
    }

    const saveFeatures = () => {
        let payload = {
            id: device.id,
            label,
            timezoneId: device.timezoneId,
            tagIds: selectedTags?.map(x => x.id) || [],
            features: {
                deviceCategory,
                apu,
                show,
            }
        }
        payload.features.hybrid = hybrid

        if (device?.deviceModel?.promiles) {
            payload.features.promiles = promiles
            payload.features.promilesOdometerCalculated = promilesOdometerCalculated
        }

        if (device?.deviceModel?.analytic) {
            payload.features.analytics = analytics
        }

        if (device?.deviceModel?.vbus || device?.deviceModel?.manufacturer?.name.toUpperCase() === "ZONAR") {
            payload.features.vbus = vbus
        }

        if (device?.deviceModel?.jbus || device?.deviceModel?.manufacturer?.name.toUpperCase() === "ZONAR") {
            payload.features.jbus = jbus
        }

        if ((device?.deviceModel?.odometerEnable && (device?.deviceModel?.jbus || device?.deviceModel?.vbus)) || device?.deviceModel?.manufacturer?.name.toUpperCase() === "ZONAR") {
            payload.features.useEcuSpeed = useEcuSpeed
            payload.features.useEcuOdometer = useEcuOdometer
            payload.features.useEcuVin = useEcuVin
        }

        if ((device?.deviceModel?.useEcuEngineHours && (device?.deviceModel?.jbus || device?.deviceModel?.vbus)) || device?.deviceModel?.manufacturer?.name.toUpperCase() === "ZONAR") {
            payload.features.useEcuEngineHours = useEcuEngineHours
        }

        if (device?.deviceModel?.driverBehavior) {
            payload.features.driverBehavior = driverBehavior
        }

        if (device?.deviceModel?.cariq) {
            payload.features.cariq = cariq
        }



        if (device?.deviceModel?.carbEnable) {
            payload.features.carb = carb
        }

        if (device?.deviceModel?.manufacturer?.name.toUpperCase() === "VidFleet".toUpperCase() || device?.deviceModel?.manufacturer?.name.toUpperCase() === "SmartWitness".toUpperCase() || device?.deviceModel?.manufacturer?.name.toUpperCase() === "LightMetrics".toUpperCase()) {

            payload.features.deviceCategory = deviceCategory
            payload.features.show = show
            payload.features.linkedMode = linkedMode

            if (device?.deviceModel?.vbus) {
                payload.features.vbus = vbus
            }
            payload.liveMode = liveMode
        }
        if (!(installed == null)) {
            payload.installed = installed;
            if (installed) {
                if (installedOn)
                    payload.installedOn = moment(installedOn).utc().format("YYYY-MM-DDTHH:mm:ss.sss") + "Z";
                else {
                    NotificationManager.error(
                        messages['feature_tab_installed_on_valid'],
                        messages['feature_tab_edit_device'],
                        3000
                    );
                    return;
                }
            }
        }

        payload.unitConfig = { billingAccountId: billingAccountId || null };

        dispatch(featureTabUpdateUnitRequest(payload));
    }



    useEffect(() => {
        if (deviceId && openModal) {
            dispatch(featureTabGetDeviceRequest(deviceId));
            dispatch(clearRedux("FEATURE_TAB_UPDATE_FEATURES", { deviceId: null }));
        }
        if (currentDevice) {
            setDevice(currentDevice);
            setShow(currentDevice?.show || false);
            setHybrid(currentDevice?.hybrid || false);
            setApu(currentDevice?.apu || false);
            setDeviceCategory(currentDevice?.deviceCategory || "Asset");
            setLabel(currentDevice?.label || "");
            setPromiles(currentDevice?.promiles || false);
            setPromilesOdometerCalculated(currentDevice?.promilesOdometerCalculated || false);
            setAnalytics(currentDevice?.analytics || false);
            setVbus(currentDevice?.vbus || false);
            setJbus(currentDevice?.jbus || false);
            setUseEcuSpeed(currentDevice?.useEcuSpeed || false);
            setUseEcuOdometer(currentDevice?.useEcuOdometer || false);
            setDriverBehavior(currentDevice?.driverBehavior || false);
            setUseEcuVin(currentDevice?.useEcuVin || false)
            setUseEcuEngineHours(currentDevice?.useEcuEngineHours || false)
            setLinkedMode(currentDevice?.linkedMode || false)
            setDeviceModel(currentDevice?.deviceModel?.name)
            setCariq(currentDevice?.cariq || false)
            setCarb(currentDevice?.carb || false)
            setInstalled(currentDevice.installed)
            setInstalledOn(currentDevice.installed ? moment(currentDevice.installedOn) : moment.now())
            setLiveMode(currentDevice?.liveMode || "Streaming")
            setSelectdTags(currentDevice?.tags?.length ? JSON.parse(currentDevice?.tags) : [])
            setBillingAccountId(currentDevice?.unitConfig?.billingAccountId || null);
            if (currentDevice?.company?.dealerId)
                dispatch(getBillingAccounts({ dealerId: currentDevice?.company?.dealerId }));

            dispatch(clearRedux("FEATURE_TAB_UPDATE_FEATURES", { currentDevice: null }));
        }

    }, [deviceId, openModal, currentDevice])

    useEffect(() => {
        if (result && result?.id) {
            dispatch(featureTabResult(result));
            dispatch(devicegetDataRequest(device?.id));
            NotificationManager.success(
                messages['feature_tab_the_device_has_been_edited'],
                messages['feature_tab_edit_device'],
                3000
            );
            dispatch(featureTabRequest(device?.id))
            dispatch(clearRedux("FEATURE_TAB_UPDATE_FEATURES", { result: null }));
            getDevice && getDevice();
            tableRef && tableRef?.current?.getData();
            closeModal();
        }
    }, [result])

    useEffect(() => {
        (!timeZones || timeZones.length === 0) && dispatch(searchEntityRequest({ key: "timezones" }));
        (!deviceModels || deviceModels.length === 0) && dispatch(searchEntityRequest({ key: "deviceModels" }));
        (!manufacturers || manufacturers.length === 0) && dispatch(searchEntityRequest({ key: "manufacturers" }));
        dispatch(searchEntityRequest({ key: "tags" }));
    }, []);

    //is SmartWitness device
    let isSW = device?.deviceModel?.manufacturer?.name?.toUpperCase() === "SMARTWITNESS";
    let selectedTimezone = timeZones.find(x => x.id === device?.timezoneId)
    let supportedTimezone = selectedTimezone ? device.timezones.find(x => x.id === selectedTimezone.name) ? true : false : false
    let showTzMsg = device?.linkedMode === true || device?.linkedByUnit?.id || false
    if (device?.linkedByUnit?.id) {
        let devModel = deviceModels.find(x => x.id === device?.linkedByUnit.deviceModelId)
        let manufacurer = null
        if (devModel)
            manufacurer = manufacturers.find(x => x.id === devModel.manufacturerId)
        if (manufacurer?.name?.toLowerCase() !== "vidfleet") {
            showTzMsg = false
        }
    }

    let alertMsg = ""
    if (showTzMsg) {
        if (supportedTimezone) {
            alertMsg = device?.linkedMode ? messages['feature_tab_tz_to_gps'] : device?.linkedByUnit?.id ? messages['feature_tab_tz_to_camera'] : ""
        } else
            alertMsg = messages['feature_tab_tz_not_supported']
    }

    return (
        <Modal
            open={openModal}
            title={`${messages['feature_tab_edit_device']} ${device?.esn ? ` - ESN ${device?.esn}` : ''}`}
            handleClose={() => closeModal()}
            position="right"
            loading={loading}
            size="small"
        >
            <ModalBody>
                <div style={{ padding: '0px 10px 20px 10px'  }}>
                    <Form
                        ref={formRef}
                        onValidSubmit={() => saveFeatures()}
                    >
                        <Grid container>
                            <Grid item xs={12}>
                                <Input
                                    label={messages['feature_tab_device_name']}
                                    placeholder={messages['feature_tab_device_name']}
                                    value={label}
                                    onChange={(value) => setLabel(value)}
                                    required
                                    requiredMessage={messages['required_field']}
                                    maxLength={50}
                                />
                            </Grid>
                            {
                                !isSW &&
                                <Grid item xs={12}>
                                    <div style={{ display: 'flex', alignItems: 'center', marginTop: 15 }}>
                                        <label className="input-normal-label" style={{ marginRight: 5 }}>{messages['feature_tab_device_category']}</label>
                                        <RadioButton
                                            onChange={() => setDeviceCategory("Asset")}
                                            value={deviceCategory === "Asset"}
                                            label={messages['feature_tab_asset']}
                                            position="end"
                                        />
                                        <RadioButton
                                            onChange={() => setDeviceCategory("Fleet")}
                                            value={deviceCategory === "Fleet"}
                                            label={messages['feature_tab_fleet']}
                                            position="end"
                                        />
                                    </div>
                                </Grid>
                            }
                        </Grid>
                        <Grid item xs={12}>
                            <Select
                                id="billingAccounts"
                                label={messages['feature_tab_billing_account']}
                                placeholder={messages['feature_tab_billing_account']}
                                options={billingAccounts || []}
                                value={billingAccountId ? billingAccounts.find(x => x.id === billingAccountId) : null}
                                textField="name"
                                valueField="id"
                                onChange={(billingAcc) => {
                                    if (billingAcc)
                                        setBillingAccountId(billingAcc.id);
                                    else
                                        setBillingAccountId(null);
                                }}
                                isClearable

                            />
                        </Grid>
                        {
                            !isSW &&
                            <Grid item xs={12}>
                                <Select
                                    id="timezones"
                                    label={messages['feature_tab_timezone']}
                                    placeholder={messages['feature_tab_timezone']}
                                    options={timeZones || []}
                                    value={device?.timezoneId ? timeZones.find(x => x.id === device?.timezoneId) : null}
                                    textField="name"
                                    valueField="id"
                                    onChange={(timezone) => {
                                        let dev = JSON.parse(JSON.stringify(device));
                                        dev.timezoneId = timezone?.id || null;
                                        setDevice(dev)
                                    }}
                                    required
                                    requiredMessage={messages['required_field']}
                                />
                                {
                                    showTzMsg &&
                                    <label className="input-normal-label" style={{ marginRight: 5, color: 'red' }}>{alertMsg}</label>
                                }
                            </Grid>
                        }
                        {
                            HasPermission(user, "uinstll", "u") &&
                            <Grid container style={{ marginTop: 5 }}>

                                <Grid item xs={6}>
                                    <label className="input-normal-label" style={{ marginRight: 5 }}>{messages['feature_tab_install_status']}</label>
                                    <ToggleSwitch
                                        id="installed_only"
                                        blueToggle={true}
                                        extraLarge={true}
                                        optionLabels={[messages['feature_tab_installed'], messages['feature_tab_pending_install']]}
                                        checked={installed}
                                        onChange={(checked) => {
                                            setInstalled(checked);
                                            if (!checked)
                                                setInstalledOn(null)
                                            else
                                                setInstalledOn(new Date())
                                        }}
                                    />
                                </Grid>
                                {
                                    installed &&
                                    <Grid item xs={6}>
                                        <label className="input-normal-label" style={{ marginRight: 5 }}>{messages['feature_tab_installed_on']}</label>
                                        <DatePicker
                                            calendarPosition="bottom"
                                            format="MMMM DD, yyyy"
                                            maxDate={moment.now()}
                                            minDate=""
                                            onChange={(date) => {
                                                setInstalledOn(date)
                                            }}
                                            placeholder={messages['feature_tab_select_date']}
                                            showButtons
                                            showTimePicker
                                            style={{
                                                width: '225px'
                                            }}
                                            timeZone={0}
                                            value={installedOn}
                                        />
                                    </Grid>
                                }
                            </Grid>
                        }
                        <Grid item xs={12}>
                            <Select
                                id="tags"
                                options={tags}
                                value={selectedTags}
                                label={messages['create_account_tags']}
                                requiredMessage={messages['required_field']}
                                onChange={(value) => {
                                    setSelectdTags(value)
                                }}
                                loading={loadingEntity}
                                valueField="id"
                                textField="label"
                                placeholder={messages['create_account_select']}
                                multiple
                                disabled={!HasPermission(user, "assgntgs", "c")}
                            />
                        </Grid>
                        {
                            <Grid container style={{ marginTop: 5, marginBottom: 25 }}>
                                <Grid item xs={12}>
                                    <label className="input-normal-label" style={{ marginRight: 5 }}>{messages['feature_tab_features']}</label>
                                </Grid>
                                <Grid item xs={6} style={{ marginTop: 5 }}>
                                    {/* <Checkbox
                                        id="update-feature-show"
                                        label={messages['feature_tab_show_in_web']}
                                        value={show}
                                        onChange={(checked) => setShow(checked)}
                                    /> */}
                                    <label className="input-normal-label" style={{ marginRight: 5 }}>{messages['feature_tab_show_in_web']}</label>
                                    <ToggleSwitch
                                        id="update-feature-show"
                                        blueToggle={true}
                                        extraLarge={true}
                                        optionLabels={[messages['devices_bulk_yes'], messages['devices_bulk_no']]}
                                        checked={show}
                                        onChange={(checked) => setShow(checked)}
                                    />
                                </Grid>
                                {
                                    device?.deviceModel?.promiles &&
                                    <Grid item xs={6} style={{ marginTop: 5 }}>
                                        {/* <Checkbox
                                            id="update-promiles"
                                            label={messages['feature_tab_promiles']}
                                            value={promiles}
                                            onChange={(checked) => setPromiles(checked)}
                                        /> */}
                                        <label className="input-normal-label" style={{ marginRight: 5 }}>{messages['feature_tab_promiles']}</label>
                                        <ToggleSwitch
                                            id="update-promiles"
                                            blueToggle={true}
                                            extraLarge={true}
                                            optionLabels={[messages['devices_bulk_yes'], messages['devices_bulk_no']]}
                                            checked={promiles}
                                            onChange={(checked) => setPromiles(checked)}
                                        />
                                    </Grid>
                                }
                                {
                                    device?.deviceModel?.promiles &&
                                    <Grid item xs={6} style={{ marginTop: 5 }}>
                                        {/* <Checkbox
                                            id="update-send-calc-odometer"
                                            label={messages['feature_tab_send_calc_odometer']}
                                            value={promilesOdometerCalculated}
                                            onChange={(checked) => setPromilesOdometerCalculated(checked)}
                                        /> */}
                                        <label className="input-normal-label" style={{ marginRight: 5 }}>{messages['feature_tab_send_calc_odometer']}</label>
                                        <ToggleSwitch
                                            id="update-send-calc-odometer"
                                            blueToggle={true}
                                            extraLarge={true}
                                            optionLabels={[messages['devices_bulk_yes'], messages['devices_bulk_no']]}
                                            checked={promilesOdometerCalculated}
                                            onChange={(checked) => setPromilesOdometerCalculated(checked)}
                                        />
                                    </Grid>
                                }
                                {
                                    device?.deviceModel?.analytic &&
                                    <Grid item xs={6} style={{ marginTop: 5 }}>
                                        {/* <Checkbox
                                            id="update-feature-apu"
                                            label={messages['feature_tab_analytics']}
                                            value={analytics}
                                            onChange={(checked) => setAnalytics(checked)}
                                        /> */}
                                        <label className="input-normal-label" style={{ marginRight: 5 }}>{messages['feature_tab_analytics']}</label>
                                        <ToggleSwitch
                                            id="update-feature-analytics"
                                            blueToggle={true}
                                            extraLarge={true}
                                            optionLabels={[messages['devices_bulk_yes'], messages['devices_bulk_no']]}
                                            checked={analytics}
                                            onChange={(checked) => setAnalytics(checked)}
                                        />
                                    </Grid>
                                }
                                {

                                    <Grid item xs={6} style={{ marginTop: 5 }}>
                                        {/* <Checkbox
                                            id="update-feature-apu"
                                            label={messages['feature_tab_apu']}
                                            value={apu}
                                            onChange={(checked) => setApu(checked)}
                                        /> */}
                                        <label className="input-normal-label" style={{ marginRight: 5 }}>{messages['feature_tab_apu']}</label>
                                        <ToggleSwitch
                                            id="update-feature-apu"
                                            blueToggle={true}
                                            extraLarge={true}
                                            optionLabels={[messages['devices_bulk_yes'], messages['devices_bulk_no']]}
                                            checked={apu}
                                            onChange={(checked) => setApu(checked)}
                                        />
                                    </Grid>
                                }
                                {

                                    <Grid item xs={6} style={{ marginTop: 5 }}>
                                        {/* <Checkbox
                                            id="update-feature-hybrid"
                                            label={messages['feature_tab_hybrid']}
                                            value={hybrid}
                                            onChange={(checked) => setHybrid(checked)}
                                        /> */}
                                        <label className="input-normal-label" style={{ marginRight: 5 }}>{messages['feature_tab_hybrid']}</label>
                                        <ToggleSwitch
                                            id="update-feature-hybrid"
                                            blueToggle={true}
                                            extraLarge={true}
                                            optionLabels={[messages['devices_bulk_yes'], messages['devices_bulk_no']]}
                                            checked={hybrid}
                                            onChange={(checked) => setHybrid(checked)}
                                        />
                                    </Grid>
                                }
                                {
                                    (device?.deviceModel?.vbus || device?.deviceModel?.manufacturer?.name.toUpperCase() === "ZONAR") &&
                                    <Grid item xs={6} style={{ marginTop: 5 }}>
                                        {/* <Checkbox
                                            id="update-vbus"
                                            label={messages['feature_tab_vbus']}
                                            value={vbus}
                                            onChange={(checked) => {
                                                setVbus(checked)
                                                if (checked)
                                                    setJbus(false)
                                                else if (!jbus) {
                                                    setUseEcuSpeed(false)
                                                    setUseEcuVin(false)
                                                    setUseEcuOdometer(false)
                                                }
                                            }}
                                        /> */}
                                        <label className="input-normal-label" style={{ marginRight: 5 }}>{messages['feature_tab_vbus']}</label>
                                        <ToggleSwitch
                                            id="update-vbus"
                                            blueToggle={true}
                                            extraLarge={true}
                                            optionLabels={[messages['devices_bulk_yes'], messages['devices_bulk_no']]}
                                            checked={vbus}
                                            onChange={(checked) => {
                                                setVbus(checked)
                                                if (checked)
                                                    setJbus(false)
                                                else if (!jbus) {
                                                    setUseEcuSpeed(false)
                                                    setUseEcuVin(false)
                                                    setUseEcuOdometer(false)
                                                }
                                            }}
                                        />
                                    </Grid>
                                }
                                {
                                    (device?.deviceModel?.jbus || device?.deviceModel?.manufacturer?.name.toUpperCase() === "ZONAR") &&
                                    <Grid item xs={6} style={{ marginTop: 5 }}>
                                        {/* <Checkbox
                                            id="update-jbus"
                                            label={messages['feature_tab_jbus']}
                                            value={jbus}
                                            onChange={(checked) => {
                                                setJbus(checked)
                                                if (checked)
                                                    setVbus(false)
                                                else if (!vbus) {
                                                    setUseEcuSpeed(false)
                                                    setUseEcuVin(false)
                                                    setUseEcuOdometer(false)
                                                }
                                            }}
                                        /> */}
                                        <label className="input-normal-label" style={{ marginRight: 5 }}>{messages['feature_tab_jbus']}</label>
                                        <ToggleSwitch
                                            id="update-jbus"
                                            blueToggle={true}
                                            extraLarge={true}
                                            optionLabels={[messages['devices_bulk_yes'], messages['devices_bulk_no']]}
                                            checked={jbus}
                                            onChange={(checked) => {
                                                setJbus(checked)
                                                if (checked)
                                                    setVbus(false)
                                                else if (!vbus) {
                                                    setUseEcuSpeed(false)
                                                    setUseEcuVin(false)
                                                    setUseEcuOdometer(false)
                                                }
                                            }}
                                        />
                                    </Grid>
                                }
                                {
                                    ((device?.deviceModel?.odometerEnable && (device?.deviceModel?.jbus || device?.deviceModel?.vbus)) || device?.deviceModel?.manufacturer?.name.toUpperCase() === "ZONAR") &&
                                    <>
                                        <Grid item xs={6} style={{ marginTop: 5 }}>
                                            {/* <Checkbox
                                                id="update-show-ecu-speed"
                                                label={messages['feature_tab_show_ecu_speed']}
                                                value={useEcuSpeed}
                                                onChange={(checked) => setUseEcuSpeed(checked)}
                                                disabled={(!jbus && !vbus)}
                                            /> */}
                                            <label className="input-normal-label" style={{ marginRight: 5 }}>{messages['feature_tab_show_ecu_speed']}</label>
                                            <ToggleSwitch
                                                id="update-show-ecu-speed"
                                                blueToggle={true}
                                                extraLarge={true}
                                                optionLabels={[messages['devices_bulk_yes'], messages['devices_bulk_no']]}
                                                checked={useEcuSpeed}
                                                onChange={(checked) => setUseEcuSpeed(checked)}
                                                disabled={(!jbus && !vbus)}
                                            />
                                        </Grid>
                                        <Grid item xs={6} style={{ marginTop: 5 }}>
                                            {/* <Checkbox
                                                id="update-use-ecu-odometer"
                                                label={messages['feature_tab_use_ecu_odometer']}
                                                value={useEcuOdometer}
                                                onChange={(checked) => {
                                                    setUseEcuOdometer(checked)
                                                    if (!checked) {
                                                        setJbus(false)
                                                        setVbus(false)
                                                    }
                                                }}
                                                disabled={(!jbus && !vbus)}
                                            /> */}
                                            <label className="input-normal-label" style={{ marginRight: 5 }}>{messages['feature_tab_use_ecu_odometer']}</label>
                                            <ToggleSwitch
                                                id="update-use-ecu-odometer"
                                                blueToggle={true}
                                                extraLarge={true}
                                                optionLabels={[messages['devices_bulk_yes'], messages['devices_bulk_no']]}
                                                checked={useEcuOdometer}
                                                onChange={(checked) => {
                                                    setUseEcuOdometer(checked)
                                                    if (!checked) {
                                                        setJbus(false)
                                                        setVbus(false)
                                                    }
                                                }}
                                                disabled={(!jbus && !vbus)}
                                            />
                                        </Grid>
                                        <Grid item xs={6} style={{ marginTop: 5 }}>
                                            {/* <Checkbox
                                                id="update-use-ecu-vin"
                                                label={messages['feature_tab_use_ecu_vin']}
                                                value={useEcuVin}
                                                onChange={(checked) => setUseEcuVin(checked)}
                                                disabled={(!jbus && !vbus)}
                                            /> */}
                                            <label className="input-normal-label" style={{ marginRight: 5 }}>{messages['feature_tab_use_ecu_vin']}</label>
                                            <ToggleSwitch
                                                id="update-use-ecu-vin"
                                                blueToggle={true}
                                                extraLarge={true}
                                                optionLabels={[messages['devices_bulk_yes'], messages['devices_bulk_no']]}
                                                checked={useEcuVin}
                                                onChange={(checked) => setUseEcuVin(checked)}
                                                disabled={(!jbus && !vbus)}
                                            />
                                        </Grid>
                                    </>
                                }
                                {
                                    ((device?.deviceModel?.useEcuEngineHours && (device?.deviceModel?.jbus || device?.deviceModel?.vbus)) || device?.deviceModel?.manufacturer?.name.toUpperCase() === "ZONAR") &&
                                    <>
                                        <Grid item xs={6} style={{ marginTop: 5 }}>
                                            {/* <Checkbox
                                                id="update-show-ecu-speed"
                                                label={messages['feature_tab_show_ecu_speed']}
                                                value={useEcuSpeed}
                                                onChange={(checked) => setUseEcuSpeed(checked)}
                                                disabled={(!jbus && !vbus)}
                                            /> */}
                                            <label className="input-normal-label" style={{ marginRight: 5 }}>{messages['feature_tab_use_ecu_engine_hours']}</label>
                                            <ToggleSwitch
                                                id="update-show-ecu-engine-hours"
                                                blueToggle={true}
                                                extraLarge={true}
                                                optionLabels={[messages['devices_bulk_yes'], messages['devices_bulk_no']]}
                                                checked={useEcuEngineHours}
                                                onChange={(checked) => setUseEcuEngineHours(checked)}
                                                disabled={(!jbus && !vbus)}
                                            />
                                        </Grid>
                                    </>
                                }
                                {
                                    device?.deviceModel?.driverBehavior &&
                                    <Grid item xs={6} style={{ marginTop: 5 }}>
                                        {/* <Checkbox
                                            id="update-driver-behavior"
                                            label={messages['feature_tab_driver_behavior']}
                                            value={driverBehavior}
                                            onChange={(checked) => setDriverBehavior(checked)}
                                        /> */}
                                        <label className="input-normal-label" style={{ marginRight: 5 }}>{messages['feature_tab_driver_behavior']}</label>
                                        <ToggleSwitch
                                            id="update-driver-behavior"
                                            blueToggle={true}
                                            extraLarge={true}
                                            optionLabels={[messages['devices_bulk_yes'], messages['devices_bulk_no']]}
                                            checked={driverBehavior}
                                            onChange={(checked) => setDriverBehavior(checked)}
                                        />
                                    </Grid>
                                }
                                {
                                    device?.deviceModel?.cariq &&
                                    <Grid item xs={6} style={{ marginTop: 5 }}>
                                        {/* <Checkbox
                                            id="update-cariq"
                                            label={messages['feature_tab_cariq']}
                                            value={cariq}
                                            onChange={(checked) => setCariq(checked)}
                                        /> */}
                                        <label className="input-normal-label" style={{ marginRight: 5 }}>{messages['feature_tab_cariq']}</label>
                                        <ToggleSwitch
                                            id="update-cariq"
                                            blueToggle={true}
                                            extraLarge={true}
                                            optionLabels={[messages['devices_bulk_yes'], messages['devices_bulk_no']]}
                                            checked={cariq}
                                            onChange={(checked) => setCariq(checked)}
                                        />
                                    </Grid>
                                }
                                {
                                    device?.deviceModel?.carbEnable &&
                                    <Grid item xs={6} style={{ marginTop: 5 }}>
                                        {/* <Checkbox
                                            id="update-cariq"
                                            label={messages['feature_tab_cariq']}
                                            value={cariq}
                                            onChange={(checked) => setCariq(checked)}
                                        /> */}
                                        <label className="input-normal-label" style={{ marginRight: 5 }}>{messages['feature_tab_carb']}</label>
                                        <ToggleSwitch
                                            id="update-cariq"
                                            blueToggle={true}
                                            extraLarge={true}
                                            optionLabels={[messages['devices_bulk_yes'], messages['devices_bulk_no']]}
                                            checked={carb}
                                            onChange={(checked) => setCarb(checked)}
                                        />
                                    </Grid>
                                }
                            </Grid>
                        }
                        {
                            (device?.deviceModel?.manufacturer?.name.toUpperCase() === "VidFleet".toUpperCase() || device?.deviceModel?.manufacturer?.name.toUpperCase() === "Smartwitness".toUpperCase() || device?.deviceModel?.manufacturer?.name.toUpperCase() === "LightMetrics".toUpperCase()) &&
                            <Grid container style={{ marginTop: 5, marginBottom: 25 }}>
                                <Grid item xs={6} style={{ marginTop: 5 }}>
                                    <label className="input-normal-label" style={{ marginRight: 5 }}>{messages['devices_main_mode']}</label>
                                    <ToggleSwitch
                                        id="update-feature-linked-mode-default"
                                        blueToggle={true}
                                        extraLarge={true}
                                        optionLabels={[messages["devices_import_camera_paired_mode"], messages["devices_import_camera_gps"]]}
                                        checked={linkedMode}
                                        onChange={(checked) => setLinkedMode(checked)}
                                    />
                                </Grid>
                                {
                                    HasPermission(user, "untlm", "u") && device?.deviceModel?.manufacturer?.name.toUpperCase() === "VidFleet".toUpperCase() && //untlm
                                    <Grid item xs={6} style={{ marginTop: 5 }}>
                                        <label className="input-normal-label" style={{ marginRight: 5 }}>{messages['devices_main_live_mode']}</label>
                                        <ToggleSwitch
                                            id="update-feature-live-mode-default"
                                            blueToggle={true}
                                            extraLarge={true}
                                            optionLabels={[messages["devices_main_live_mode_straming"], messages["devices_main_live_mode_photo"]]}
                                            checked={liveMode === "Streaming" ? true : false}
                                            onChange={(checked) => setLiveMode(checked ? "Streaming" : "Photo")}
                                        />
                                    </Grid>
                                }
                            </Grid>
                        }
                    </Form>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['cancel']}
                </Button>
                <Button
                    className="btn-dark-blue"
                    onClick={() => formRef?.current?.submit()}
                    disabled={loading}
                >
                    {messages['save']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default UpdateFeature;